import {
  faBookOpen,
  faCopy,
  faDollarSign,
  faHome,
  faQuestion,
  faUsers,
  faGift,
  faEnvelope,
  faVideo,
  faClone,
} from "@fortawesome/free-solid-svg-icons";
import { getFromLocal } from "../utils/localStorage";

export const MAIN_MENU_ITEMS = (trial) => [
  { name: "Home", icon: faHome, url: "/tool/", disabled: false },
  { name: "Themes", icon: faCopy, url: "/tool/templates", disabled: trial },
  {
    name: "Recent Projects",
    icon: faClone,
    url: "/tool/projects",
    disabled: false,
    showTooltip: false,
  },
  {
    name: "My Videos",
    icon: faVideo,
    url: "/tool/video",
    disabled: false,
    showTooltip: false,
  },
  { name: "Redeem Points", icon: faGift, id: "redeemPoints", disabled: false },
  // { name: 'My Team', icon: faUsers },
];

export const BOTTOM_MENU_ITEMS = [
  {
    name: "Pricing & Plans",
    icon: faDollarSign,
    url: "https://www.vidboard.ai/pricing/",
  },
  {
    name: "Tutorials",
    icon: faBookOpen,
    url: "https://www.youtube.com/playlist?list=PLsJkcBtwcUOmamL_ynImRPtkQSYzqz7QE",
  },
  {
    name: "Ask For Help",
    icon: faEnvelope,
    onClick: () => {
      window.location.href = "mailto:admin@vidboard.ai";
    },
  },
];

export const TEMPLATE_LAYOUT = {
  HORIZONTAL: "landscape",
  VERTICAL: "portrait",
};
export const TEMPLATE_LAYOUT_OPTIONS = [
  { label: "Horizontal", value: TEMPLATE_LAYOUT.HORIZONTAL },
  { label: "Vertical", value: TEMPLATE_LAYOUT.VERTICAL },
];
